<template>
  <div class="footer-toolbar-outer">
    <div class="footer-toolbar container">
      <div class="ion-hide">
<!--      <div class="h-layout">-->
        <div @click="imageClickEvent('home')">
          <img v-if="$store.state.toolbarActivePosition === 'main'" src="/assets/common/footer-toolbar/home-active.png" width="16" height="19" />
          <img v-else src="/assets/common/footer-toolbar/home.png" width="16" height="19" />
          <div class="label">Home</div>
        </div>
        <div @click="imageClickEvent('mytextbook')">
          <img v-if="$store.state.toolbarActivePosition === 'mytextbook'" src="/assets/common/footer-toolbar/mytextbook-active.png" width="22" height="19" />
          <img v-else src="/assets/common/footer-toolbar/mytextbook.png" width="22" height="19" />
          <div class="label">Curriculum Progress</div>
        </div>
        <div @click="imageClickEvent('preview')">
          <img v-if="$store.state.toolbarActivePosition === 'home'" src="/assets/common/footer-toolbar/find-active.png" width="75" height="75" />
          <img v-else src="/assets/common/footer-toolbar/find.png" width="75" height="75" />
          <div class="label">Find a course</div>
          <!-- 버튼 눌려짐 버그로 원복
          <img v-if="$store.state.toolbarActivePosition === 'preview'" src="/assets/common/footer-toolbar/find-active.png" width="75" height="75" />
          <img v-else src="/assets/common/footer-toolbar/find.png" width="75" height="75" />
          <div class="label">Find a course</div>
          -->
        </div>
        <div @click="imageClickEvent('join')">
          <img v-if="$store.state.toolbarActivePosition === 'join'" src="/assets/common/footer-toolbar/join-active.png" width="19" height="19" />
          <img v-else src="/assets/common/footer-toolbar/join.png" width="19" height="19" />
          <div class="label">Participate</div>
        </div>
        <div @click="imageClickEvent('mypage')">
          <img v-if="$store.state.toolbarActivePosition === 'mypage'" src="/assets/common/footer-toolbar/mypage-active.png" width="18" height="19" />
          <img v-else src="/assets/common/footer-toolbar/mypage.png" width="18" height="19" />
          <div class="label">My</div>
        </div>
      </div>

      <div class="new_footer_bar" style="z-index: 1; margin: auto 10px;">
        <div @click="imageClickEvent($c.MAIN_TAB.LISTEN_TEACHER)" class="footer-menu-item">
          <img v-if="$store.state.toolbarActivePosition === $c.MAIN_TAB.LISTEN_TEACHER"
               style="width: 25px; height: 27px;"
               src='/assets/new/ic_bott_teacher_on@2x.png' />
          <img v-else src='/assets/new/ic_bott_teacher_off@2x.png'
               style="width: 25px; height: 27px;"/>
          <div class="label" :class="{'active' : $store.state.toolbarActivePosition === $c.MAIN_TAB.LISTEN_TEACHER}">듣는 선생님</div>
        </div>
        <div @click="imageClickEvent($c.MAIN_TAB.CURRICULUM)" class="footer-menu-item">
          <img v-if="$store.state.toolbarActivePosition === $c.MAIN_TAB.CURRICULUM"
               src='/assets/new/ic_bott_course_on@2x.png'  style="width: 24px; height: 24px;"/>
          <img v-else src='/assets/new/ic_bott_course_off@2x.png' style="width: 24px; height: 24px;" />
          <div class="label" :class="{'active' : $store.state.toolbarActivePosition === $c.MAIN_TAB.CURRICULUM}">교과진도</div>
        </div>
        <div @click="imageClickEvent($c.MAIN_TAB.HOME)" class="footer-menu-item">
          <img v-if="$store.state.toolbarActivePosition === $c.MAIN_TAB.HOME"
               src='/assets/new/ic_bott_home_on@2x.png' style="width: 24px; height: 24px;"/>
          <img v-else src='/assets/new/ic_bott_home_off@2x.png' style="width: 24px; height: 24px;"/>
          <div class="label" :class="{'active' : $store.state.toolbarActivePosition === $c.MAIN_TAB.HOME}">홈</div>
        </div>
        <div @click="imageClickEvent($c.MAIN_TAB.COMMUNITY)" class="footer-menu-item">
          <img v-if="$store.state.toolbarActivePosition === $c.MAIN_TAB.COMMUNITY"
               src='/assets/new/ic_bott_community_on@2x.png' style="width: 38px; height: 27px;" />
          <img v-else src='/assets/new/ic_bott_community_off@2x.png' style="width: 39px; height: 27px;" />
          <div class="label" :class="{'active' : $store.state.toolbarActivePosition === $c.MAIN_TAB.COMMUNITY}">커뮤니티</div>
        </div>
        <div @click="imageClickEvent($c.MAIN_TAB.SEARCH_LECTURE)" class="footer-menu-item">
          <img v-if="$store.state.toolbarActivePosition === $c.MAIN_TAB.SEARCH_LECTURE"
               src='/assets/new/ic_bott_search_on@2x.png' style="width: 20px; height: 22px;"/>
          <img v-else src='/assets/new/ic_bott_search_off@2x.png' style="width: 20px; height: 22px;"/>
          <div class="label" :class="{'active' : $store.state.toolbarActivePosition === $c.MAIN_TAB.SEARCH_LECTURE}">강의검색</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as alert from '../../utils/alert';
import * as biz from '../../utils/biz';

export default {
  name: "FooterToolbar",
  data() {
    return {
      isActive: "main"
    }
  },
  created() {
    // 미니플레이어 뛰우기
    const footer = document.querySelector('body > ion-app > div.player > div.mini-player');
    if (footer !== null) footer.bottom = "90px";
  },
  methods: {
    /**
     * 이전판본에서 구현하였던 함수
     * @param div
     */
    // imageClickEvent(div) {
    //
    //   biz.setAudioPlayer();
    //
    //   const today = new Date();
    //   switch (div) {
    //     case "home":
    //       this.$store.state.toolbarActivePosition = "main";
    //       this.$router.replace({path: "/", query: {key: today.toISOString()}});
    //       break;
    //     case "mytextbook":
    //       if (!biz.isLogin(this)) {
    //         alert.alertLogin(this);
    //         return;
    //       }
    //
    //       this.$store.state.toolbarActivePosition = "mytextbook";
    //       this.$router.replace({path: "/mytextbook/course", query: {key: today.toISOString()}});
    //       // alert.alert("교과진도 서비스 준비 중 입니다.", "확인");
    //       break;
    //     case "preview":
    //       this.$store.state.toolbarActivePosition = "home";
    //       this.$router.replace({path: "/home/home", query: {key: today.toISOString()}});
    //       break;
    //     case "join":
    //       this.$store.state.toolbarActivePosition = "join";
    //       this.$router.replace({path: "/mycontent/main", query: {key: today.toISOString()}});
    //       break;
    //     case "mypage":
    //       this.$store.state.toolbarActivePosition = "mypage";
    //       this.$router.replace({path: "/mypage/main", query: {key: today.toISOString()}});
    //       break;
    //   }
    // }
    /**
     * 새판본에서 구현하는 함수
     * @param div
     */
    imageClickEvent(div) {

      // biz.setMiniAudioPlayer();

      const today = new Date();
      switch (div) {
        case this.$c.MAIN_TAB.HOME:
          // this.$store.state.toolbarActivePosition = this.$c.MAIN_TAB.HOME;
          // this.$router.replace({path: "/home", query: {key: today.toISOString()}});
          this.$router.push({path: "/home", query: {key: today.toISOString()}});
          break;
        case this.$c.MAIN_TAB.LISTEN_TEACHER:
          // if (!biz.isLogin(this)) {
          //   alert.alertLogin(this);
          //   return;
          // }
          // this.$store.state.toolbarActivePosition = this.$c.MAIN_TAB.LISTEN_TEACHER;
          this.$router.push({path: "/listen/mission"});
          // this.$router.replace({path: "/listen", query: {key: today.toISOString()}});
          // alert.alert("교과진도 서비스 준비 중 입니다.", "확인");
          break;
        case this.$c.MAIN_TAB.CURRICULUM:
          // this.$store.state.toolbarActivePosition = this.$c.MAIN_TAB.CURRICULUM;
          this.$router.push({path: "/curriculum", query: {key: today.toISOString()}});
          // this.$router.replace({path: "/curriculum", query: {key: today.toISOString()}});
          break;
        case this.$c.MAIN_TAB.COMMUNITY:
          // this.$store.state.toolbarActivePosition = this.$c.MAIN_TAB.COMMUNITY;
          // this.$router.push({path: "/community", query: {key: today.toISOString()}});
          this.$router.push({path: "/community/self_tb"});
          // this.$router.replace({path: "/community", query: {key: today.toISOString()}});
          break;
        case this.$c.MAIN_TAB.SEARCH_LECTURE:
          // this.$store.state.toolbarActivePosition = this.$c.MAIN_TAB.SEARCH_LECTURE;
          this.$router.push({path: "/search", query: {key: today.toISOString()}});
          // this.$router.replace({path: "/search", query: {key: today.toISOString()}});
          break;
      }
    }
  }
}
</script>

<style scoped lang="scss">
div.footer-toolbar-outer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 105;
}
div.footer-toolbar {
  position: relative;
  width: 100%;
  height: 90px;
  background-color: white;
  border-top: 1px solid $line-third-color;
  box-shadow: 0px -3px 29px -1px rgba(111, 111, 111, 0.35);

  display: flex;
  justify-content: space-between;
  align-items: center;

  background-image: url("/assets/common/footer-toolbar/bg_footer_bar.png");
  background-size: 100% 100%;

}

div.footer-toolbar:before {
  content: '';
  position: absolute;
  top: -16px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: white;
  box-shadow: 0px -7px 3px -5px rgba(0, 0, 0, 0.1);
}

.new_footer_bar {
  display: flex;
  align-items: center;
  width: 100%;

  div {
    width: 25%;
    text-align: center;
    font-size: $font-base10;
    font-weight: 500;

    div.label {
      //margin-top: -2px;
      width: 100%;
      font-size: $font-base10;
      font-weight: bold;
    }
  }
  div.active {
    color: $primary-color;
  }
  .footer-menu-item {
    img {
      width: 25px;
      height: 25px;
    }
  }
}
</style>
